import { type SvgIconProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { type ComponentType } from 'react';

const useStyles = makeStyles((theme) => ({
    icon: {
        color: theme.palette.common.midGrey,
        fontSize: '1.125rem',
    },
}));

interface Props {
    icon: ComponentType<SvgIconProps>;
}

/**
 * Small muted icon shared by the chain counts, overview card, and suggestions table. It sits next to adjacent
 * text, so it is decorative and always aria-hidden.
 */
const ChainMetaIcon = ({ icon: Icon }: Props) => {
    const classes = useStyles();
    return <Icon className={classes.icon} aria-hidden="true" />;
};

export default ChainMetaIcon;
